export default {
  placeholder: 'Seleccione una opción',
  emptyOption: 'Ninguna'
}

export const en = {
  placeholder: 'Select an option',
  emptyOption: 'None'
}
export const ca = {
  placeholder: 'Seleccioneu una opció',
  emptyOption: 'Cap'
}
